import styled from 'styled-components';
import { TABLET_WIDTH, COLOR } from '~~elements/Const';
import DefaultAvatar from '~~elements/static/DefaultAvatar.jpg';

export const StyledDiv = styled.div`
  padding: 1rem 10rem 0;

  .greet {
    display: flex;
    padding: 0 1rem 2rem;
    align-items: center;
    &--name {
      font-size: 1.5rem;
      margin-left: 0.5rem;
    }
    &--pic {
      margin-left: 0.5rem;
      border-radius: 50%;
      width: 4rem;
      height: 4rem;
      display: block;
      object-fit: cover;
      &.default {
        background-image: url(${DefaultAvatar});
        background-size: cover;
        background-position: center;
      }
    }
  }

  .panel {
    display: flex;
    width: 100%;
  }
  .multi-section-list {
    width: 10rem;
    > * {
      margin-bottom: 0.5rem;
    }
  }

  .section-list {
    width: 10rem;
    height: fit-content;
    border-radius: 0.5rem;
    border: 1px #000 solid;
    text-align: left;
    &--title {
      background: #f9f9f9;
      font-size: 1.2rem;
      border-bottom: 1px #ccc solid;
      padding: 0.5rem 0.5rem;

      &:first-child {
        border-radius: 0.5rem 0.5rem 0 0;
      }
    }
    &--item {
      position: relative;
      display: block;
      font-size: 1.1rem;
      text-decoration: none;
      cursor: pointer;
      padding: 0.2rem 0.5rem;
      border-bottom: 1px #eee solid;
      color: unset;
      &:hover {
        background: #eee;
      }

      &:last-child {
        border-radius: 0 0 0.5rem 0.5rem;
      }

      &.disabled {
        background: #eee;
        cursor: not-allowed;
      }

      &.highlight {
        background: ${COLOR.secondary};
        color: white;
        font-size: 1rem;
        font-weight: bold;
      }
    }

    .selected {
      ::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        content: '';
        width: 3px;
        background: ${COLOR.primary};
      }
      background: #eee;
    }
  }

  .section {
    padding: 0 5rem 1rem;
    text-align: left;
    width: 80%;
    &--title {
      padding: 0 0 1rem;
      font-size: 1.5rem;
      border-bottom: 1px #ccc solid;
    }
    &--subtitle {
      padding: 0.5rem 0;
      font-size: 1.2rem;
      border-bottom: 1px #ccc solid;
      > button {
        margin-left: 0.5rem;
      }
    }
    &--footer {
      padding: 0.5rem 0;
      font-size: 1.2rem;
      border-top: 1px #ccc solid;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      > button {
        margin: 0 0.5rem;
      }
    }
    &--loading {
      width: 100%;
      padding: 2rem 0;
    }

    &.lg {
      padding: 0 0 1rem 5rem;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    padding: 5rem 0 0;
    .panel {
      flex-direction: column;
      align-items: center;
    }
    .multi-section-list {
      width: 80%;
      > .section-list {
        width: 100%;
      }
    }
    .section-list {
      width: 80%;
    }

    .section {
      padding: 2rem 0;
      text-align: left;
      width: 90%;

      &.lg {
        padding: 2rem 0;
      }
    }
  }
`;

export const StyledForm = styled.form`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;
  letter-spacing: 1px;

  .icon {
    width: 30%;
  }

  .box {
    width: 100%;
    margin-top: 6%;
    padding-top: 8%;
    border-top: 1px solid rgb(10, 74, 154, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .input-field {
      width: 80%;
      display: flex;
      align-items: center;
      margin-bottom: 8%;
      img {
        width: 1.5rem;
        margin-right: 12px;
      }
      .input-box {
        display: flex;
        width: 100%;
        justify-content: space-between;
        input:not(:first-child) {
          margin-left: 0.5rem;
        }
      }
    }

    .error-msg {
      font-size: 0.8rem;
      color: #e8196e;
      margin: 4% 0 6%;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    .box {
      margin-top: 10%;
      padding-top: 12%;
      width: 90%;

      .input-field {
        width: 100%;
        &.--multi-input {
          align-items: flex-start;
        }
        label {
          width: 1.1rem;
          margin-right: 8px;
        }
        .input-box {
          flex-direction: column;
          input:not(:first-child) {
            margin-left: 0;
            margin-top: 5%;
          }
        }
      }
    }
  }
`;

export const TwoColumnStyledForm = styled.form`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;

  .icon {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &--pic {
      &:not(.square) {
        border-radius: 50%;
      }
      width: 8rem;
      height: 8rem;
      display: block;
      margin-bottom: 0.5rem;
      object-fit: cover;
      &.default {
        background-image: url(${DefaultAvatar});
        background-size: cover;
        background-position: center;
      }
    }
    &--box {
      display: flex;
      justify-content: center;
    }
  }

  .cover {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    &--box {
      display: flex;
      justify-content: start;
    }
    &--pic {
      position: relative;
      z-index: 2;
      width: 80%;
      text-align: start;
      &:after {
        content: '';
        display: block;
        padding-bottom: 75%;
      }
      > img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      &.default {
        background-image: url(${DefaultAvatar});
        background-size: cover;
        background-position: center;
      }
    }
  }

  .box {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;

    label {
      display: block;
    }
    .input-field {
      width: 80%;
      display: flex;
      align-items: center;
      margin-bottom: 2rem;
      font-size: 1rem;
      .input-box {
        display: flex;
        width: 100%;
        justify-content: space-between;
        input:not(:first-child) {
          margin-left: 0.5rem;
        }
      }
    }

    .error-msg {
      font-size: 0.8rem;
      color: #e8196e;
    }

    .success-msg {
      font-size: 0.8rem;
      color: green;
    }
  }

  .divider {
    border: 1px #222 solid;
    width: 100%;
    height: 0px;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column-reverse;
    .icon {
      width: 100%;
    }
    .cover {
      justify-content: center;
      align-items: center;
    }
    .box {
      width: 90%;
      .input-field {
        width: 100%;
        &.--multi-input {
          align-items: flex-start;
        }
        .input-box {
          flex-direction: column;
          input:not(:first-child) {
            margin-left: 0;
            margin-top: 5%;
          }
        }
      }
    }
  }
`;
